import { Container } from '@mui/material';
import { useMatch } from 'react-router';

import { NoSSRGuard } from 'modules/common/components/NoSSRGuard';
import { homeRoutesConfig } from 'domains/home/routes';

import { Breadcrumbs } from '../Breadcrumbs';
import { HeaderContent } from './components/HeaderContent';
import { useHeaderStyles } from './useHeaderStyles';
import { useHeaderBannerHeight } from '../HeaderBanner/useHeaderBannerHeight';

export interface HeaderProps {
  className?: string;
}

export const Header = ({ className }: HeaderProps) => {
  const bannerHeight = useHeaderBannerHeight();

  const isHomePage = Boolean(useMatch(homeRoutesConfig.home.path));
  const isNewsPage = Boolean(useMatch(homeRoutesConfig.news.path));

  const { classes, cx } = useHeaderStyles({
    bannerHeight,
    hasBreadcrumbs: !isHomePage && !isNewsPage,
  });

  return (
    <header className={cx(classes.root, className)}>
      <Container className={classes.container}>
        <Breadcrumbs />
        <div className={classes.right}>
          <NoSSRGuard>
            <div className={classes.buttons}>
              <HeaderContent />
            </div>
          </NoSSRGuard>
        </div>
      </Container>
    </header>
  );
};
